var Login = function() {
  var accountApiEndpoint = "https://api.brandingbrand.com/accounts/v1/api";
  var jwtIssuerEndpoint = "https://jwt.prod.bbhosted.com";

  if (window.location.hostname.includes('core-inf3.prod')) {
    accountApiEndpoint = "https://tpx8cf4mrd.execute-api.us-east-1.amazonaws.com/accounts/v1/api";
    jwtIssuerEndpoint = "https://jwt.prod.bbhosted.com";
  } else if (window.location.hostname.includes('gemini-inf3.uat') || window.location.hostname.includes('gemini-stage.uat') || window.location.hostname.includes('gemini.uat') || window.location.hostname.includes('gemini-engagement.uat')) {
    accountApiEndpoint = "https://api.brandingbrand.com/accounts/v1/api";
    jwtIssuerEndpoint = "https://jwt.prod.bbhosted.com";
  } else if (window.location.hostname.includes('localhost')) {
    jwtIssuerEndpoint = "http://localhost:3001";
    accountApiEndpoint = "http://localhost:3003/api";
  }

  $('.copyright > .year').html(moment().format('YYYY'));
  
  var successfulLogin = function (response) {
    if (response && response.user && response.user.api_key) {
      document.cookie = 'apikey=' + JSON.stringify(response.user.api_key) + '; path=/;';
      localStorage.setItem('user', JSON.stringify(response.user));
      document.location.href = document.location.pathname === '/' ? '/properties' : (document.location.pathname + document.location.search);
    } else {
      throw new Error('Unable to login');
    }
  }

  var failedLogin = function(response) {
    var error = (response && response.responseJSON && response.responseJSON.error) || {};
    var message = error.message || 'Sorry, an error occurred. Please try again later.';

    if (response
      && response.status === 401
      && response.responseText
      && response.responseText.indexOf('Invalid credentials' > -1)
    ) {
      // Handle invalid credentials response from JWT server
      message = 'Invalid Credentials.';
    }

    if (error.code === 'MFA_REQUIRED') {
      $('#mfa-input').show();
      if (error.hasPhone) {
        $('#alternativeMethod').show();
      }
    } else {
      var $loginForm = $('.login-form');
      $loginForm.find('.error-list').html("<li>" + message + "</li>").show();
      $loginForm.find('.error-box').show();
    }
  }

  var handleLogin = function() {
    var $form = $('.login-form');
    $form.find('.sendSMS').on('click', sendSmsCode);

    $form.validate({
      wrapper: 'li',
      errorLabelContainer: $form.find('.error-list'),
      errorContainer: $form.find('.error-box'),
      focusInvalid: false, // do not focus the last invalid input
      rules: {
        username: {
          required: true
        },
        password: {
          required: true
        },
        remember: {
          required: false
        },
        mfa: {
          required: false,
          number: true
        }
      },
      messages: {
        username: {
          required: "Username is required."
        },
        password: {
          required: "Password is required."
        }
      },
      invalidHandler: function(errorList) {
        $form.find('.error-box').fadeOut().fadeIn();
      },
      submitHandler: function(form) {
        handleAuth({
          email: form.username.value,
          password: form.password.value,
          multiFactorAuthToken: form.mfa.value
        });
      }
    });
  };

  var handleForgetPassword = function() {
    var $form = $('.forget-form');

    $form.validate({
      wrapper: 'li',
      errorLabelContainer: $form.find('.error-list'),
      errorContainer: $form.find('.error-box'),
      focusInvalid: false, // do not focus the last invalid input
      rules: {
        email: {
          required: true,
          email   : true
        }
      },
      messages: {
        email: {
          required: "Email is required."
        }
      },
      highlight: function(element) {
        $(element).siblings('i').addClass('font-red-thunderbird fa-times');
      },
      unhighlight: function(element) {
        $(element).siblings('i').removeClass('font-red-thunderbird fa-times');
      },
      success: function(label, element) {
        $(element).siblings('i').addClass('font-green fa-check');
      },
      invalidHandler: function(errorList) {
        $form.find('.error-box').fadeOut().fadeIn();
      },
      submitHandler: function(form) {
        var url = accountApiEndpoint + "/Accounts/resetPasswordRequest";
        var email = form.email.value;

        $.post(url, { email: email })
          .done(function() {
            $('.content').html(
              "<p>We've sent an email to the address associated with your account. Please check your email for instructions on how to reset your password.</p>"
              + "<p>If you don't see the email, check your junk or spam folders.</p>"
            );
          })
          .fail(function() {
            $form.find('.error-box').html('Unable to reset your password. Please try again.');
          });
        return false;
      }
    });

    $('.login-form input, .forget-form input').keypress(function(e) {
      if (e.which == 13) {
        var targetForm = $(e.target).closest('form');

        if (targetForm.validate().form()) {
          targetForm.submit();
        }

        return false;
      }
    });

    jQuery('#forget-password').click(function() {
      jQuery('.login-form').hide();
      jQuery('.forget-form').show();
    });

    jQuery('#back-btn').click(function() {
      jQuery('.login-form').show();
      jQuery('.forget-form').hide();
    });

  }

  var handleResetPassword = function(userId, token) {
    var $form = $('.reset-form');

    $form.validate({
      wrapper: 'li',
      errorLabelContainer: $form.find('.error-list'),
      errorContainer: $form.find('.error-box'),
      focusInvalid: false, // do not focus the last invalid input
      rules: {
        password: {
          required: true,
          minlength: 8,
          maxlength: 72,
          remote: {
            url: accountApiEndpoint + "/Accounts/checkPasswordRequirements",
            type: 'POST'
          }
        },
        passwordConfirm: {
          equalTo: '#password'
        }
      },
      messages: {
        password: {
          required: "Password is required.",
          remote: "Password is too common. Please choose a different password."
        },
        passwordConfirm: {
          equalTo: "Passwords must match."
        }
      },
      highlight: function(element) {
        $(element).siblings('i').addClass('font-red-thunderbird fa-times');
      },
      unhighlight: function(element) {
        $(element).siblings('i').removeClass('font-red-thunderbird fa-times');
      },
      success: function(label, element) {
        $(element).siblings('i').addClass('font-green fa-check');
      },
      invalidHandler: function(errorList) {
        $form.find('.error-box').fadeOut().fadeIn();
      },
      submitHandler: function(form) {
        var $submitBtn = $form.find('button[type="submit"]');

        var submitBtnText = $submitBtn.text();
        $submitBtn.prop('disabled', true).text('Loading...');
        var url = accountApiEndpoint + "/Accounts/resetPassword";
        var password = form.password.value;

        $.post(url, {
          userId: userId,
          token: token,
          password: password
        })
        .done(function(response) {
          $('.content').html('<p>Your password was successfully updated.</p> <p>You will now be logged in.</p>');
          setTimeout(function() {
            successfulLogin(response)
          }, 5000);
        })
        .fail(failedLogin)
        .always(function() {
          $submitBtn.prop('disabled', false).text(submitBtnText)
        });
      }
    });
  }

  var handleAuth = function(credentials) {
    // First exchange the user's email and password for a JWT
    var url = jwtIssuerEndpoint + "/login";
    $.post(url, credentials)
      .done(function (response, _status, xhr) {
        if (response && typeof response === 'string') {
          var user;
          try {
            var base64 = response.split('.')[1] || '';
            user = JSON.parse(atob(base64));
          } catch (e) {
            throw new Error('Unable to decode jwt');
          }
          if (user) {
            document.cookie = 'token=' + response + '; path=/;';
            document.cookie = 'refresh-token=' + xhr.getResponseHeader("refresh-token") + '; path=/;';

            // Second, fetch the user's account info. This includes an api_key
            // that is required to talk to legacy systems such as Brand CMS.
            $.get({
              url: accountApiEndpoint + '/Accounts/' + user.sub,
              headers: {
                Authorization: 'Bearer ' + response
              }
            })
            .done(function(userDataResponse) {
              // The response from Accounts currently doesn't include the user's
              // roles so parse them out of the JWT.
              if (!userDataResponse.roles) {
                userDataResponse.roles = user.roles;
              }

              successfulLogin({
                user: userDataResponse
              })
            })
            .fail(failedLogin);
          }
        } else {
          successfulLogin(response);
        }
      })
      .fail(failedLogin);
  }

  var sendSmsCode = function() {
    var url = accountApiEndpoint + "/Accounts/sendMfaTokenViaSms";
    var $form = $('.login-form');

    if ($form.valid()) {
      $('#alternativeMethod, #resend').hide();
      var form = $form.get(0);
      var email = form.username.value;
      var password = form.password.value;

      $.post(url, {
        email: email,
        password: password
      })
        .done(function() {
          setTimeout(function() {
            $('#resend').show();
          }, 29 * 1000);
        })
        .fail(function(response) {
          $('#alternativeMethod, #resend').hide();
          var message = 'Sorry, we were unable to send the code over SMS';
          if (response && response.responseJSON && response.responseJSON.error && response.responseJSON.error.message) {
            message = response.responseJSON.error.message;
          }

          $('#sms-error').html(message).show();
          $('#resend').show();
        });
    }
  }

  return {
    //main function to initiate the module
    init: function() {
      // window.onSignIn = function (googleUser) {
      //   var id_token = googleUser.getAuthResponse().id_token;
      //   handleAuth({ google_token: id_token });
      // }
      handleLogin();
      handleForgetPassword();

      var queryStringParams = window.location.search.slice(1).split('&').map(function(variable) {
        return variable.split('=');
      });
      var qspMap = new Map(queryStringParams);
      if (qspMap.has('expiredToken')) {
        $('.login-form').find('.error-box').html("<ul class='error-list list-unstyled'><li>Your login token has expired. Please login again.</li></ul>").show();
      }
      if (qspMap.has('uid') && qspMap.has('token')) {
        var userId = qspMap.get('uid');
        var token = qspMap.get('token');
        $('form').hide();
        $('.reset-form').show();
        handleResetPassword(userId, token);
      }
    }

  };

}();

jQuery(document).ready(function() {
  Login.init();
});



// WEBPACK FOOTER //
// ./webroot/assets/pages/scripts/login.js